import styled from 'styled-components';

const MOBILE_BREAKPOINT = '768px';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 82px 24px 24px;
  background-color: #fff;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 96px 16px 16px;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

export const Logo = styled.img`
  max-width: 262px;
  width: 100%;
  height: 82px;
  object-fit: contain;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 615px;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  padding: 16px 32px 32px;
  box-sizing: border-box;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 16px;
  }
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #070B64;
  text-align: center;
  margin: 0 0 24px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
`;

export const ReasonTitle = styled.p`
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 20px 0;
  text-align: center;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
  color: ${({ theme }) => theme.tokens?.color?.text?.primary || '#333'};
`;

export const FormGroup = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormGroupContent = styled.div`
  width: 100%;
  max-width: 515px;
  min-width: 0;
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.tokens?.color?.text?.primary || '#333'};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  max-width: 100%;
  height: 48px;
  padding: 12px 16px;
  font-size: 1rem;
  border: 1px solid ${({ $hasError }) => ($hasError ? '#B40E3B' : '#5C5C5C')};
  border-radius: 8px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
  box-sizing: border-box;

  &:hover {
    border-color: #5C5C5C;
  }

  &:focus {
    outline: none;
    border-color: ${({ $hasError }) => ($hasError ? '#B40E3B' : '#0A0E80')};
  }
`;

export const HelperText = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.tokens?.color?.text?.secondary || '#666'};
  margin-top: 8px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
`;

export const ReasonCard = styled.div<{ $hasExpandableContent?: boolean }>`
  width: 100%;
  max-width: 615px;
  min-width: 0;
  min-height: ${({ $hasExpandableContent }) => ($hasExpandableContent ? 500 : 344)}px;
  background: ${({ theme }) => theme.tokens?.color?.background?.primary || '#fff'};
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  box-sizing: border-box;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 16px;
  }
`;

export const EmailsToNotifySection = styled.div`
  margin-top: 16px;
  margin-left: 28px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-left: 0;
  }
`;

export const AddEmailRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  min-width: 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
`;

export const AddEmailInputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  display: flex;
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
`;

export const AddEmailInput = styled.input<{ $hasError?: boolean; $hasErrorIcon?: boolean }>`
  width: 100%;
  max-width: 100%;
  height: 48px;
  box-sizing: border-box;
  padding: 12px ${({ $hasErrorIcon }) => ($hasErrorIcon ? 40 : 16)}px 12px 16px;
  font-size: 1rem;
  border: 1px solid ${({ $hasError }) => ($hasError ? '#B40E3B' : '#5C5C5C')};
  border-radius: 8px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
  box-sizing: border-box;

  &:hover {
    border-color: #5C5C5C;
  }

  &:focus {
    outline: none;
    border-color: ${({ $hasError }) => ($hasError ? '#B40E3B' : '#0A0E80')};
  }
`;

export const InputErrorIcon = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #B40E3B;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: bold;
  pointer-events: none;
`;

export const EmailsToNotifyHelperText = styled.p<{ $hasError?: boolean }>`
  font-size: 0.875rem;
  color: ${({ $hasError }) => ($hasError ? '#B40E3B' : '#666')};
  margin: 0;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
  order: 3;
  flex-basis: 100%;
  width: 100%;

  @media (min-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 4px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    order: unset;
    flex-basis: unset;
    margin-top: 0;
  }
`;

export const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #E7E8FD;
  color: #2C31C9;
  border: 1px solid #2C31C9;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
`;

export const ChipEmailText = styled.span`
  font-weight: 700;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #2C31C9;
  cursor: pointer;
  padding: 0 4px;
  font-size: 1rem;
  line-height: 1;
  opacity: 0.8;
  order: -1;

  &:hover {
    opacity: 1;
  }

  svg {
    width: 18px;
    height: 18px;
    display: block;
  }
`;

export const TellUsMoreSection = styled.div`
  margin-top: 16px;
  margin-left: 28px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-left: 0;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  input[type='radio'] {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    margin: 0;
    flex-shrink: 0;
    accent-color: #5C5C5C;
    cursor: pointer;

    &:hover {
      accent-color: #5C5C5C;
    }

    &:checked {
      accent-color: #2C31C9;
    }
  }

  label {
    font-size: 1rem;
    font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
    cursor: pointer;
    min-width: 0;
    overflow-wrap: break-word;
    word-break: break-word;
  }
`;

export const ErrorText = styled.p`
  color: #B40E3B;
  font-size: 0.875rem;
  margin-bottom: 16px;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', sans-serif;
`;

export const DividerLine = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 24px 0;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
  width: 100%;

  button {
    min-width: 200px;
    width: 100%;
    max-width: 280px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      min-width: unset;
      max-width: 100%;
    }
  }
`;

export const StyledConfirmButton = styled.div`
  button {
    &[disabled] {
      background-color: rgba(159, 159, 159, 0.32) !important;
      color: #9F9F9F !important;
    }
    &:not([disabled]) {
      background-color: #0D12AB !important;
      &:hover {
        background-color: #0A0E80 !important;
      }
      &:active {
        background-color: #050847 !important;
      }
    }
  }
`;

export const StyledAddButton = styled.div`
  flex-shrink: 0;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }

  button {
    background-color: transparent !important;
    border: 1px solid #0D12AB !important;
    color: #0D12AB !important;
    &:hover {
      background-color: #E7E8FD !important;
      border-color: #0A0E80 !important;
      color: #0A0E80 !important;
    }
    &:active {
      background-color: #050847 !important;
      border-color: #050847 !important;
      color: #fff !important;
    }
  }
`;
